import isUndefined from './is-undefined.js';
export default function createAbort() {
    const fn = (promise) => {
        fn.promise = isUndefined(promise)
            ? Promise.resolve(true)
            : promise;
    };
    fn.promise = Promise.resolve(false);
    return fn;
}
//# sourceMappingURL=create-abort.js.map